import React from 'react';
import Grid from 'components/Custom/Grid';
import { getWitnessInspections } from 'utils/WitnessInspectionUtils';
import WitnessInspection from 'classes/WitnessInspection';
import { useAppContext } from 'hooks/useAppContext';

export default function ObservationGrid() {
  const columns = WitnessInspection.columns;
  const { selectedProject } = useAppContext();

  return (
    <Grid
      columns={columns}
      title="Observations"
      getRecords={getWitnessInspections}
      selectedProject={selectedProject}
      component="Inspections"
      enable={{ update: false, delete: false }}
      inspectionColumnTitle="Inspection #"
      options={{
        pageSizeOptions: [10, 15, 25],
        pageSize: 10
      }}
    />
  );
}
